import { DISTRIBUTION_STATUS } from 'shared/constants/distribution';

export function isRecentlyActive(count) {
  return Number(count) > 0;
}

export function isSurveyGroupActive(surveyGroup, statusByDistributionId) {
  return surveyGroup.surveys?.some(survey => survey.distributions?.some(
    distribution => statusByDistributionId.get(distribution.id) === DISTRIBUTION_STATUS.ACTIVE,
  )) || false;
}

export function groupInactiveRoutes(items, parentPath, activeEmptyLabel) {
  if (!items?.length || String(parentPath).endsWith('/inactive')) {
    return items;
  }

  const visible = [];
  const inactive = [];
  for (const item of items) {
    if (item.active === false) {
      inactive.push(item);
    } else {
      visible.push(item);
    }
  }

  if (!inactive.length) {
    return items;
  }

  const noActiveItems = activeEmptyLabel && !items.some(item => item.active === true);

  return [
    ...visible,
    ...(noActiveItems ? [{
      key: `${parentPath}/no-active`,
      path: `${parentPath}/no-active`,
      label: activeEmptyLabel,
      disabled: true,
      link: false,
    }] : []),
    {
      key: `${parentPath}/inactive`,
      path: `${parentPath}/inactive`,
      label: 'Inactive',
      link: false,
      children: inactive,
    },
  ];
}

export function findOpenKeys(items, pathname) {
  const keys = [];
  for (const item of items || []) {
    if (item.children) {
      const childKeys = findOpenKeys(item.children, pathname);
      keys.push(...childKeys);
      if (childKeys.length && item.key) {
        keys.push(item.key);
      }
    }
    if (item.key && pathname.startsWith(item.key)) {
      keys.push(item.key);
    }
  }
  return [...new Set(keys)];
}
